var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlack = function SvgSlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#slack_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DE1C59",
    d: "M4.259 12.612c0 1.146-.935 2.081-2.08 2.081a2.086 2.086 0 0 1-2.08-2.08c0-1.146.935-2.081 2.08-2.081h2.08zm1.048 0c0-1.145.935-2.08 2.08-2.08s2.081.935 2.081 2.08v5.209c0 1.145-.935 2.08-2.08 2.08a2.086 2.086 0 0 1-2.081-2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35C5F0",
    d: "M7.388 4.259a2.085 2.085 0 0 1-2.081-2.08c0-1.145.935-2.08 2.08-2.08s2.081.935 2.081 2.08v2.08zm0 1.048c1.145 0 2.08.935 2.08 2.08s-.935 2.081-2.08 2.081H2.179a2.086 2.086 0 0 1-2.08-2.08c0-1.146.935-2.081 2.08-2.081z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EB57D",
    d: "M15.742 7.388c0-1.146.933-2.081 2.079-2.081 1.145 0 2.08.935 2.08 2.08s-.935 2.081-2.08 2.081h-2.08zm-1.049 0c0 1.145-.935 2.08-2.08 2.08a2.086 2.086 0 0 1-2.081-2.08V2.179c0-1.145.935-2.08 2.08-2.08s2.081.935 2.081 2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBB02E",
    d: "M12.612 15.741c1.146 0 2.081.934 2.081 2.08s-.935 2.08-2.08 2.08a2.086 2.086 0 0 1-2.081-2.08v-2.08zm0-1.048a2.086 2.086 0 0 1-2.08-2.08c0-1.146.935-2.081 2.08-2.081h5.209c1.145 0 2.08.935 2.08 2.08s-.935 2.081-2.08 2.081z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "slack_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgSlack;